import React, {useState, useEffect} from 'react';
import { sixYardAxios } from '../../sixYardAxios';
import VideoSection from '../../components/containers/videoSection/videoSection';
import SixYardBreif from '../../components/aboutUs/sixYardBreif/sixYardBreif';
import Vision from '../../components/aboutUs/vision/vision';
import Mission from '../../components/aboutUs/mission/mission';
import Values from '../../components/aboutUs/values/values';
import Reviews from '../../components/aboutUs/reviews/reviews';
import RoadTripAndAcheivments from '../../components/aboutUs/roadTripAndAcheivments/roadTripAndAcheivments';
import Team from '../../components/aboutUs/team/team';
import Locations from '../../components/aboutUs/locations/locations';

const AboutUs = () => {
    const [introduction, setIntroduction] = useState({});
    const [vision, setVision] = useState({});
    const [mission, setMission] = useState({});
    const [values, setValues] = useState({});
    const [reviews, setReviews] = useState({});
    const [timeLine, setTimeLine] = useState({});
    const [team, setTeam] = useState({});
    const [locations, setLocations] = useState({});

    useEffect(() => {
        fetchAboutUs();
    }, [localStorage.getItem('language')])

    const fetchAboutUs = async () => {
        try {
            const res = await sixYardAxios.get("/about-us");    
            setIntroduction(res.data.data.introduction);
            setVision(res.data.data.vision);
            setMission(res.data.data.mission);
            setValues(res.data.data.values);
            setReviews(res.data.data.testimonials);
            setTimeLine(res.data.data.milestones);
            setTeam(res.data.data.team);
            setLocations(res.data.data.locations);
        } catch (error) { }
    };

    return (
        <div>
            <VideoSection src={introduction?.video?.url} />
            <SixYardBreif introduction={introduction}/>
            <Vision vision={vision}/>
            <Mission mission={mission}/>
            <Values values={values} />
            <Reviews reviews={reviews}/>
            <RoadTripAndAcheivments timeLineData={timeLine}/>
            <Team team={team}/>
            <Locations locations={locations}/>
        </div>
    )
}

export default AboutUs;